import {useClient, useDictionary} from '@adamlip/okeoke.client';
import {Card, CardBody, CardFooter, CardHeader} from '@nextui-org/react';
import IconComponent from 'components/IconComponent';

function AchCard({ach}) {
  const {getName} = useClient();
  const {getValue} = useDictionary();
  console.log(ach);
  if (ach?.stampsNeeded) {
    return (
      <div>
        <Card className='bg-default '>
          <CardHeader>{ach?.customName ? getName(ach?.customName) : getValue(`app_${ach?.achievementType}`)}</CardHeader>

          <CardBody className='pt-0'>
            {ach?.attributes?.description && <p className='mb-1'>{getName(ach?.attributes?.description)}</p>}
            <div className='flex flex-row gap-2 flex-wrap w-full'>
              {Array.from({length: ach.stampsNeeded}, (_, i) => (
                <div
                  key={i}
                  style={{
                    opacity: i >= ach?.userStamps?.length % ach?.stampsNeeded ? 0.3 : 1,
                  }}>
                  <div className='h-6 w-6'>
                    <IconComponent iconCode={ach?.attributes?.stampIcon || 'hamburger'} className={'current'} />
                  </div>
                </div>
              ))}
            </div>
          </CardBody>
          <CardFooter className='justify-between'>
            <p className='opacity-80'>
              {ach?.userAchievements?.length} {getValue('app_vip_userAchievements_count')}
            </p>
            <p>
              {ach?.userStamps?.length % ach?.stampsNeeded}/{ach?.stampsNeeded}
            </p>
          </CardFooter>
        </Card>
      </div>
    );
  }
  return (
    <div>
      <Card className='bg-default '>
        <CardHeader>{ach?.customName ? getName(ach?.customName) : getValue(`app_${ach?.achievementType}`)}</CardHeader>

        <CardBody>{ach?.attributes?.description && <p>{getName(ach?.attributes?.description)}</p>}</CardBody>
        <CardFooter className='justify-between'>
          <p className='opacity-80'>
            {ach?.userAchievements?.length} {getValue('app_vip_userAchievements_count')}
          </p>
        </CardFooter>
      </Card>
    </div>
  );
}

export default AchCard;
